import React, { useEffect, useState } from 'react'
import Layout from '../components/Layout';
import classes from "./Leaderboard.module.css";
import { Calendar } from 'primereact/calendar';
import { Button } from 'primereact/button';
import moment from 'moment-timezone';
import { leaderboardApi } from '../http/http';
import { useDispatch, useSelector } from 'react-redux';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { removeToken } from '../store/slices/tokenSlice';
import Spinner from '../components/Spinner';

const Leaderboard = () => {
    const [monthYear, setMonthYear] = useState(new Date());
    const { token } = useSelector(state => state?.tokenSlice);
    const [leaderboard, setLeaderboard] = useState([]);
    const [loading, setLoading] = useState(true);

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const handleMonthYearChange = (e) => {
        setMonthYear(e.value);
    };

    const fetchLeaderboard = async () => {
        try {
            setLoading(true);
            const startDate = moment(monthYear).startOf("month").format("YYYY-MM-DD");
            const endDate = moment(monthYear).endOf("month").format("YYYY-MM-DD");
            const response = await leaderboardApi(startDate, endDate, token);
            console.log(response, 'response...');
            setLeaderboard(response?.data?.result);
            setLoading(false);

        } catch (error) {
            console.log(error, 'error---');
            setLoading(false);

            if (error?.response?.status == 403) {
                dispatch(removeToken());
                toast.error("Token Expired, Please Login Again!");
                navigate('/');
            }
            else {
                toast.error(error?.response?.data?.error?.error || error?.response?.error?.error || error?.response?.error || "Something Went Wrong!");
            }
        }
    }

    useEffect(() => {
        fetchLeaderboard();
    }, [monthYear]);

    console.log(monthYear, 'my');

    return (
        <Layout active={3}>
            <div className={classes.date_containers}>
                <div className={classes.date_container}>
                    <Calendar
                        showIcon
                        showButtonBar
                        placeholder="Month / Year"
                        style={{ width: "100%" }}
                        view="month"
                        dateFormat="mm/yy"
                        value={monthYear}
                        onChange={handleMonthYearChange}
                    />
                </div>
            </div>

            {loading ? <Spinner /> : (

                <div className={classes.table_container}>
                    <DataTable
                        value={[...leaderboard]}
                        emptyMessage="No Data Found!"
                        showGridlines
                        responsive
                        scrollable
                        scrollDirection="both"
                        header={
                            <p className={classes.table_header}>
                                Leaderboard
                            </p>
                        }
                        scrollHeight="500px"
                    >
                        <Column
                            header="Rank"
                            body={(_, { rowIndex }) => rowIndex + 1}
                        />

                        <Column
                            field="msisdn"
                            header="Msisdn"
                        />
                        <Column
                            field="name"
                            header="Name"
                            body={(rowData) => {
                                if (rowData?.name) {
                                    return <p>{rowData?.name}</p>
                                }
                                else {
                                    return <p>No Name</p>
                                }
                            }
                            }
                        />
                        <Column
                            field="image"
                            header="Image"
                            body={(rowData) => {
                                if (rowData?.image) {
                                    return <img src={`${rowData?.image}`} alt="image"
                                        style={{ width: "48px", height: "48px", objectFit: "cover", borderRadius: "50%" }}
                                    />
                                }
                                else {
                                    return <p>No Image</p>
                                }
                            }
                            }
                        />
                        <Column
                            field="total_points"
                            header="Total Points"
                        />
                        <Column
                            field="datetime"
                            header="Date Time"
                            body={(rowData) =>
                                moment(rowData?.datetime).format("DD-MM-YYYY HH:MM:SS") + " IST"
                            }
                        />
                    </DataTable>
                </div>
            )}

        </Layout>
    )
}

export default Leaderboard